var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import * as go from '../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { AppComponentBase } from '../../../shared/app-component-base';
var DiagramTemplateService = /** @class */ (function (_super) {
    __extends(DiagramTemplateService, _super);
    function DiagramTemplateService(injector, elementFactory) {
        var _this = _super.call(this, injector) || this;
        _this.elementFactory = elementFactory;
        return _this;
    }
    DiagramTemplateService.prototype.getNodePaletteTemplateMap = function () {
        var paletteTemplateMap = new go.Map();
        _.forEach(this.elementFactory.nodeElements, function (element) { return paletteTemplateMap.add(element.getCategoryKey(), element.getPaletteTemplate()); });
        return paletteTemplateMap;
    };
    DiagramTemplateService.prototype.getLinkPaletteTemplateMap = function () {
        var paletteTemplateMap = new go.Map();
        _.forEach(this.elementFactory.linkElements, function (element) { return paletteTemplateMap.add(element.getCategoryKey(), element.getPaletteTemplate()); });
        return paletteTemplateMap;
    };
    DiagramTemplateService.prototype.getNodeDiagramTemplateMap = function (containerId) {
        var diagramTemplateMap = new go.Map();
        _.forEach(this.elementFactory.nodeElements, function (element) { return diagramTemplateMap.add(element.getCategoryKey(), element.getDiagramTemplate(containerId)); });
        return diagramTemplateMap;
    };
    DiagramTemplateService.prototype.getLinkDiagramTemplateMap = function () {
        var diagramTemplateMap = new go.Map();
        _.forEach(this.elementFactory.linkElements, function (element) { return diagramTemplateMap.add(element.getCategoryKey(), element.getDiagramTemplate()); });
        return diagramTemplateMap;
    };
    DiagramTemplateService = __decorate([
        Injectable()
    ], DiagramTemplateService);
    return DiagramTemplateService;
}(AppComponentBase));
export { DiagramTemplateService };
